import React, { useState } from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faChevronUp,
    faChevronDown
}
from "@fortawesome/free-solid-svg-icons";


export default function HomeDocumentScroller(
{
    scrollPercent = 0,
    currentCard = 0,
    maxCard = 0,
    scrollUp,
    scrollDown
})
{
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [hoverUp, setHoverUp] =
        useState(false);

    const [hoverDown, setHoverDown] =
        useState(false);


    //--------------------------------------------------------
    // New light blue accent
    //--------------------------------------------------------

    const LIGHT_BLUE =
        "#45afe0";


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            style={{
                position:
                    "fixed",

                left:
                    "calc(50% + 25px)",

                bottom:
                    "22px",

                transform:
                    "translateX(-50%)",

                width:
                    "320px",

                display:
                    "flex",

                alignItems:
                    "center",

                justifyContent:
                    "space-between",

                height:
                    "60px",

                padding:
                    "0px 18px",

                borderRadius:
                    "30px",

                background:
                    "rgba(18,18,20,.88)",

                backdropFilter:
                    "blur(18px)",

                WebkitBackdropFilter:
                    "blur(18px)",

                border:
                    "1px solid rgba(255,255,255,.08)",

                boxShadow:
                    "0 10px 30px rgba(0,0,0,.30)",

                zIndex:
                    9999
            }}
        >


            {/* ================================================
                UP
            ================================================= */}

            <div
                onClick={
                    scrollUp
                }

                onMouseEnter={
                    () =>
                        setHoverUp(true)
                }

                onMouseLeave={
                    () =>
                        setHoverUp(false)
                }

                style={{
                    width:
                        "34px",

                    height:
                        "34px",

                    borderRadius:
                        "17px",

                    display:
                        "flex",

                    justifyContent:
                        "center",

                    alignItems:
                        "center",

                    cursor:
                        "pointer",

                    background:
                        hoverUp
                            ?
                            "linear-gradient(180deg, #69c4ed 0%, #2695cc 100%)"
                            :
                            "linear-gradient(180deg, #343434 0%, #191919 100%)",

                    boxShadow:
                        hoverUp
                            ?
                            "0 0 20px rgba(69,175,224,0.42)"
                            :
                            "inset 0 1px 0 rgba(255,255,255,.08)",

                    transition:
                        "all .25s ease"
                }}
            >

                <FontAwesomeIcon
                    icon={faChevronUp}
                    style={{
                        color:
                            "#ffffff",

                        fontSize:
                            "14px"
                    }}
                />

            </div>


            {/* ================================================
                MIDDLE
            ================================================= */}

            <div
                style={{
                    flex:
                        1,

                    marginLeft:
                        "18px",

                    marginRight:
                        "18px"
                }}
            >


                {/* --------------------------------------------
                    Label
                --------------------------------------------- */}

                <div
                    style={{
                        display:
                            "flex",

                        justifyContent:
                            "space-between",

                        color:
                            LIGHT_BLUE,

                        fontSize:
                            "11px",

                        fontWeight:
                            500,

                        marginBottom:
                            "6px"
                    }}
                >

                    <div>
                        Documents
                    </div>

                </div>


                {/* --------------------------------------------
                    Progress rail
                --------------------------------------------- */}

                <div
                    style={{
                        height:
                            "6px",

                        borderRadius:
                            "3px",

                        background:
                            "rgba(255,255,255,.08)",

                        overflow:
                            "hidden"
                    }}
                >

                    <div
                        style={{
                            width:
                                (scrollPercent * 100) + "%",

                            height:
                                "100%",

                            borderRadius:
                                "3px",

                            background:
                                "linear-gradient(90deg, #2695cc 0%, #45afe0 100%)",

                            boxShadow:
                                "0 0 8px rgba(69,175,224,0.28)",

                            transition:
                                "width .35s ease"
                        }}
                    />

                </div>

            </div>


            {/* ================================================
                DOWN
            ================================================= */}

            <div
                onClick={
                    scrollDown
                }

                onMouseEnter={
                    () =>
                        setHoverDown(true)
                }

                onMouseLeave={
                    () =>
                        setHoverDown(false)
                }

                style={{
                    width:
                        "34px",

                    height:
                        "34px",

                    borderRadius:
                        "17px",

                    display:
                        "flex",

                    justifyContent:
                        "center",

                    alignItems:
                        "center",

                    cursor:
                        "pointer",

                    background:
                        hoverDown
                            ?
                            "linear-gradient(180deg, #69c4ed 0%, #2695cc 100%)"
                            :
                            "linear-gradient(180deg, #343434 0%, #191919 100%)",

                    boxShadow:
                        hoverDown
                            ?
                            "0 0 20px rgba(69,175,224,0.42)"
                            :
                            "inset 0 1px 0 rgba(255,255,255,.08)",

                    transition:
                        "all .25s ease"
                }}
            >

                <FontAwesomeIcon
                    icon={faChevronDown}
                    style={{
                        color:
                            "#ffffff",

                        fontSize:
                            "14px"
                    }}
                />

            </div>

        </div>
    );
}